import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { Nominal } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: Nominal
}

export function NominalPriceReview(props: Props) {
  const { config } = props
  const { formatCurrency } = useNumbers()

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.nominalPrice}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          discount: formatCurrency(config.value),
        }}
      />
    </SummaryRow.Value>
  )
}
